// utils/formatters.ts
export function formatCurrencyAmount(
  value: number | string | null | undefined
): string {
  if (value === null || value === undefined || value === "") {
    return "—";
  }

  let numberValue: number;

  if (typeof value === "string") {
    numberValue = Number(
      value
        .replace(/\s/g, "")
        .replace(",", ".")
    );
  } else {
    numberValue = value;
  }

  if (isNaN(numberValue)) {
    return "—";
  }

  return numberValue.toLocaleString("pl-PL", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  });
}
